import request from '_utils/request'

export function listspecial(data) {
    return request({
      url: '/web_api/special/column/list',
      method: 'post',
      data: data
    })
  }
export function infospecial(id) {
    return request({
      url: '/web_api/special/column/'+ id,
      method: 'get'
    })
  }
  export function imgList(data) {
    return request({
      url: '/web_api/special/work/list',
      method: 'post',
      data: data
    })
  }
  export function listcolumnZt(data) {
    return request({
      url: '/web_api/special/columnZt/list',
      method: 'post',
      data: data
    })
  }
export function dutyList(data) {
  return request({
    url: '/web_api/duty/config/list',
    method: 'post',
    data: data
  })
}